import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import i18n from 'i18n-js';
import { formatSinceTime } from '@helpers';
import { ContainerStyle } from '@interfaces/base';

interface NCFileFirstRanInfoProps extends ContainerStyle {
  C: ColorFunction;
  firstRanOn: string;
  firstRanByMachineName: string;
  fontType?: keyof typeof font;
  color?: string;
}

const NCFileFirstRanInfo: FC<NCFileFirstRanInfoProps> = ({ C, firstRanByMachineName, firstRanOn, containerStyle, fontType = 'Subhead 1', color = 'Label/Dark/Secondary' }) => {
  return (
    <View style={[{ marginTop: scale(8) }, containerStyle]}>
      <Text style={[{ color: C(color), textAlign: 'center' }, font[fontType]]}>{i18n.t('First ran on')} {formatSinceTime(firstRanOn)}</Text>
      <Text style={[{ color: C(color), textAlign: 'center' }, font[fontType]]}>
        {i18n.t('on')} {firstRanByMachineName}
      </Text>
    </View>
  );
};

export default ColorWrapper(NCFileFirstRanInfo);
